"use strict";
exports.showupReducer = {};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducer.ts
 ** module id = 98
 ** module chunks = 1
 **/